import React from "react";

type Props = { count: number; user: string | null };

export default function RowCount({ count, user }: Props) {
  if (!user) return null;
  return (
    <div style={{ marginTop: 12, color: "#6b7280" }}>
      Showing {count} row{count === 1 ? "" : "s"} for <strong>{user}</strong>
    </div>
  );
}
